import { z } from "zod";

// Update a placement. `active` stays bare .optional() (never null — house rule). Bounds mirror the
// create schema; `slot` stays a 32-bit integer.
export const updatePlacementRequestSchema = z.object({
  zone: z.string().min(1).max(100).nullable().optional(),
  slot: z.number().int().min(0).max(2147483647).nullable().optional(),
  label: z.string().min(1).max(200).nullable().optional(),
  description: z.string().max(1000).nullable().optional(),
  active: z.boolean().optional(),
});
